import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import React from 'react'
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../lib/Media'
import Typography from '@ntuctech/devex-tangram/Typography'

const TableContainer = styled.ul`
  border: 1px solid ${defaultTheme.ColorBaseMineShaft80};
  border-radius: 4px;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0.5rem 1rem 0;
  }
`

const Item = styled.li`
  display: grid;
  grid-template-columns: 3fr 7fr;
  gap: 1rem;
  align-items: center;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: ${defaultTheme.ColorBaseMineShaft700};
  border-top: 1px solid ${defaultTheme.ColorBaseMineShaft80};
  &:nth-child(odd) {
    background-color: ${defaultTheme.ColorBaseMineShaft40};
  }
  &:first-child {
    border-top: none;
  }
`

const Column = styled(Typography)`
  white-space: normal;
`

export const TableAttribute = ({ metadata }) => {
  return (
    <TableContainer>
      {metadata.value.map(({ key, name, value }) => {
        return (
          <Item key={key} data-testid={`table_attribute_row_${key}`}>
            <Column variant="bodySBold">{name}</Column>
            <Column variant="bodyS">{value}</Column>
          </Item>
        )
      })}
    </TableContainer>
  )
}
